import { SELECTORS } from "../../constants";

export function tabbableElements(containedWithin) {
	containedWithin = containedWithin ?? document;

	return Array.from(containedWithin.querySelectorAll(SELECTORS.TabbableElements))
		.filter(element => !element.hasAttribute("tabindex") || element.getAttribute("tabindex") != -1) //remove tabindex=-1 from usually tabbables
		.filter(element => !!element.offsetParent); //remove non-displayed/pseudo elements https://stackoverflow.com/a/53068496
}